import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../services/auth/auth.service';
import { MIN_STATUS } from '../../utils/constants';

@Injectable()
export class DocumentationAccessGuard {
  constructor(private authService: AuthService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (environment.disableGuards) {
      return true;
    }

    if (
      parseInt(this.authService.getStatus().getValue(), 10) >=
      MIN_STATUS.attachDocumentation
    ) {
      this.authService.updateStatus(true);
      return true;
    }

    return false;
  }
}
